import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { getTitleForTier, sortTiers } from '../../../../helpers/tiers';
import Tier from './TierVariantB';
import './TiersVariantB.scss';
import { TIER_FEATURE_IDS, TIER_IDS } from '../../../../constants/Tiers';
import { useVideolandAccountState } from '../../../../hooks/useVideolandAccountState';
import classNames from 'classnames';
import TierLoader from '../loaders/TierLoaderVariantB';
import { EVT_TIER_OPTION_SELECT } from '../../../../constants/EventTypes';
import { useDispatch } from 'react-redux';
import { analyticsPush } from '../../../../actions/applicationActions';
import { getProceedText, proceedToPushUrl, renderTierFeature } from '../onboardingHelpers';

const Tiers = ({
	tiers,
	selectedTier,
	isPromo = true,
	onSelectTier,
	proceedUrl,
	onClickProceed,
	children,
	toggleSidebar,
	isPromoAllowed,
	isSavodTierSelected,
	setIsSavodTierSelected,
	isSavodExperiment,
}) => {
	const [isTierButtonClicked, setIsTierButtonClicked] = useState(false);
	const dispatch = useDispatch();
	const dispatchAnalyticsPush = (payload, eventType) => dispatch(analyticsPush(payload, eventType));
	const selectedTierRef = useRef(TIER_IDS.PREMIUM);
	const { isBlackFriday } = useVideolandAccountState();
	const isSelected = (tier) => selectedTier && selectedTier.id === tier.id;
	let sortedTiers = tiers.length > 0 && sortTiers(tiers).reverse();
	const TIERS_LENGTH = 4;
	const tvGemist = [
		{
			id: 'FREE',
			pricing: {
				recurring: 0,
			},
			promoPricing: {
				recurring: 0,
			},
		},
	];
	if (sortedTiers.length > 0) {
		sortedTiers = [...Object.values(sortedTiers), ...tvGemist];
	}

	const proceedText =
		selectedTier &&
		getProceedText({
			isPromo,
			title: getTitleForTier(selectedTier).title,
		});

	const pushTierSelectedAnalytics = (tierId) => {
		dispatchAnalyticsPush(
			{
				label: `select ${tierId}`,
			},
			EVT_TIER_OPTION_SELECT
		);
	};

	useEffect(() => {
		if (isTierButtonClicked) {
			if (
				isSavodExperiment &&
				(selectedTier.id === TIER_IDS.PREMIUM || selectedTier.id === TIER_IDS.STANDARD) &&
				!isSavodTierSelected
			) {
				return setIsSavodTierSelected(true);
			} else {
				onClickProceed(selectedTier, proceedText);
				proceedToPushUrl(proceedUrl);
			}
		}
	}, [
		isSavodExperiment,
		isTierButtonClicked,
		selectedTier,
		onClickProceed,
		proceedText,
		proceedUrl,
		isSavodTierSelected,
		setIsSavodTierSelected,
	]);

	const showTiers = sortedTiers?.length > 0;

	return (
		<>
			<section className="tiersB-container">
				<div className={classNames('tiersB')}>
					{showTiers ? (
						sortedTiers.map((tierItem) => (
							<Tier
								tierItem={tierItem}
								selected={isSelected(tierItem)}
								onClick={(tier) => {
									selectedTierRef.current = tier.id;
									onSelectTier(tier.id);
									pushTierSelectedAnalytics(tier.id);
								}}
								isBlackFriday={isBlackFriday}
								isSavodExperiment={isSavodExperiment}
								onButtonClick={(tier) => {
									onSelectTier(tier.id);
									setIsTierButtonClicked(true);
								}}
								toggleSidebar={toggleSidebar}
								isPromo={isPromo}
								isPromoAllowed={isPromoAllowed}
								key={tierItem.id}
							/>
						))
					) : (
						<TierLoader tiersLength={TIERS_LENGTH} />
					)}
				</div>
				<div className="tierB-features">
					{Object.keys(TIER_FEATURE_IDS).map((tierFeatureId) =>
						renderTierFeature({
							featureId: tierFeatureId,
							tierId: selectedTier?.id,
							showTiers: showTiers,
							isSavodExperiment: isSavodExperiment,
						})
					)}
				</div>
				{children}
			</section>
		</>
	);
};

Tiers.propTypes = {
	tiers: PropTypes.array.isRequired,
	selectedTier: PropTypes.object,
	isPromo: PropTypes.bool,
	onSelectTier: PropTypes.func.isRequired,
	proceedUrl: PropTypes.string,
	onClickProceed: PropTypes.func.isRequired,
	children: PropTypes.node,
	withTvg: PropTypes.bool,
};

export default Tiers;
